<div class="body-container">
  <div class="suspended-account">
    <mat-card appearance="outlined" fxFlex style="margin-top: 15px;">
      <mat-card-title>
         {{ accountStatusDisplay }}
      </mat-card-title>
      <mat-card-content>
        <div *ngIf="!isLoading" style="padding-top: 15px;">
          {{ displayMessage }}
        </div>
        <ng-container *ngIf="isLoading">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
